export enum NavMode {
    Over = 'over',
    Side = 'side',
    Fold = 'fold',
}
